import { useQuery } from "@apollo/client/react";
import { GetAllLines } from "./line.gql";

export default function useGetLines(variables) {
  const {
    data: { lines },
    data,
    loading,
    error,
  } = useQuery(GetAllLines, { variables: { activeOnly: variables?.activeOnly } });

  return { data, error, lines, loading };
}
